export default function FinalCTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 px-6 bg-zinc-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-96 h-96 border border-cyan-500/30 rotate-45"></div>
        <div className="absolute bottom-10 left-10 w-64 h-64 border border-cyan-500/20"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold mb-8">
          <strong>Ready to Stabilize and Scale?</strong>
        </h2>
        
        <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
          Let's discuss how we can eliminate chaos and install systems that drive measurable results.
        </p>

        <button 
          onClick={scrollToContact}
          className="px-10 py-5 bg-cyan-500 text-black text-lg font-bold rounded-md hover:bg-cyan-400 transition-all shadow-lg hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer mb-6"
        >
          Book a Call
        </button>

        <p className="text-sm text-gray-500 font-mono">
          Domain: mrprimeops.com
        </p>
      </div>
    </section>
  );
}
